<template>
  <div>
    <MasterLayout>
      <div class="dashboard_first_row">
        <div class="buttons_section">
          <div>
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :custom-shortcuts="customShortcuts"
              color="#4b2c72"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
            />
          </div>
          <!-- <div class="pos_select_branch">
              <input class="btn details_btn px-3 mr-3" v-model="terminalId">
            </div> -->

          <!-- select vendors -->
          <div class="pos_select_branch">
            <select class="btn details_btn px-3 mr-3" v-model="vendor">
              <option disabled value="selectVendor">
                {{ $t("text.posRevamp.selectVendor") }}
              </option>
              <option value="">{{ $t("text.cBank.showAll") }}</option>
              <option
                v-for="(vendor, index) in vendors"
                :key="index"
                v-bind:value="vendor"
              >
                {{ vendor }}
              </option>
            </select>
          </div>

          <div class="pos_select_branch">
            <select class="btn details_btn px-3 mr-3" v-model="status">
              <option disabled value="selectAStatus">
                {{ $t("text.bPos.selectStatus") }}
              </option>
              <option value="">{{ $t("text.bPos.showAll") }}</option>
              <option value="00">{{ $t("text.bPos.approved") }}</option>
              <option value="0x0x0">{{ $t("text.bPos.declined") }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-3 pos_trans_card_holder">
          <div class="col-lg-4 col-md-4 remove_padding-right pos_trans_card">
            <div class="shadow-sm card_container_1 pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.bPos.totTransact") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (4).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h4 class="font-weight-bold">
                  {{ branch ? branch.currencyCode : ""
                  }}{{ totalTransactionsAmount }} /
                </h4>
                <small class="dashboard__card__header_bottom font-weight-bold">
                  {{ totalTransactions }}
                </small>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 remove_padding-right pos_trans_card">
            <div class="shadow-sm card_container_1 pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.bPos.successfulTransactions") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (2).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h4 class="font-weight-bold">
                  {{ branch ? branch.currencyCode : ""
                  }}{{ totalSuccessfulTransactionsAmount }} /
                </h4>
                <small
                  class="dashboard__card__header_bottom font-weight-bold"
                  >{{ totalSuccessfulTransactions }}</small
                >
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 remove_padding-right pos_trans_card">
            <div class="shadow-sm card_container_1 pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.bPos.failedTransactions") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (3).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h4 class="font-weight-bold">
                  {{ branch ? branch.currencyCode : ""
                  }}{{ totalFailedTransactionsAmount }} /
                </h4>
                <small
                  class="dashboard__card__header_bottom font-weight-bold"
                  >{{ totalFailedTransactions }}</small
                >
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-4 col-md-4 remove_padding-right pos_trans_card">
            <div class="shadow-sm card_container_1 pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.cBank.transaction.totalBalance") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (3).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h4 class="font-weight-bold">
                  {{ branch ? branch.currencyCode : "" }}{{ branchBalance }}
                </h4>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <section>
        <div class="pos_table">
          <div class="row top_section_row" v-show="!showLoader">
            <div class="col-md-8">
              <span class="sec_text_color">
                {{ $t("text.bPos.posTransactBtw") }}
                {{ $route.query.startDate }} -
                {{ $route.query.endDate }}
              </span>
              <span> </span>
            </div>

            <div
              v-show="!showLoader"
              class="col-md-4 d-flex align-items-center"
            >
              <button class="btn btn-light mr-3" @click="getTransactions">
                <img src="@/assets/img/refresh.svg" />
              </button>

              <button
                class="btn btn-light mr-3"
                :class="{
                  disabled: !previousToken || showLoader,
                  'cursor-not-allowed': !previousToken || showLoader,
                }"
                @click="handlePreviousPage"
                :disabled="!previousToken || showLoader"
              >
                <img src="@/assets/img/arrowLeft.png" />
              </button>

              <p class="mb-0 mr-3 text-muted">
                {{ $t("text.actionButtons.page") }} {{ pages }}
              </p>

              <button
                class="btn btn-light"
                :class="{
                  disabled: !continuationToken || showLoader,
                  'cursor-not-allowed': !continuationToken || showLoader,
                }"
                @click="handleNextPage"
                :disabled="!continuationToken || showLoader"
              >
                <img src="@/assets/img/arrowRight.png" />
              </button>
            </div>
          </div>

          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="false"
            :allowSorting="true"
            :toolbar="toolbar"
            :pageSettings="pageSettings"
            :searchSettings="search"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick"
            :rowDataBound="rowDataBound"
            :allowTextWrap="true"
            :excelQueryCellInfo="excelQueryCellInfo"
            :locale="usedLang"
          >
            <e-columns>
              <e-column
                width="80"
                field="index"
                :allowSorting="false"
                headerText="#"
              ></e-column>
              <e-column
                field="paymentDate"
                width="200"
                :headerText="$t('text.bPos.transactionDate')"
                :format="formatOptions"
                type="date"
              ></e-column>
              <e-column
                field="pumpName"
                width="150"
                :headerText="$t('text.bPos.pump')"
              ></e-column>
              <e-column
                field="amount"
                format="N2"
                width="180"
                :headerText="`${$t('text.bPos.amount')} (${
                  branch ? branch.currency : ''
                })`"
              ></e-column>
              <e-column
                field="stan"
                width="220"
                :headerText="$t('text.bPos.stan')"
              ></e-column>
              <e-column
                field="retrievalReferenceNumber"
                width="220"
                :headerText="$t('text.bPos.rrn')"
              ></e-column>
              <e-column
                field="maskedPan"
                width="220"
                :headerText="$t('text.bPos.maskedPan')"
              ></e-column>
              <e-column
                field="statusDescription"
                width="200"
                :headerText="$t('text.actionButtons.status')"
              ></e-column>
              <e-column
                width="300"
                :template="actionTemplate"
                :headerText="$t('text.actionButtons.title')"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </div>

        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
    <POSModal :modalData="modalData"></POSModal>
    <BranchPOSettlement :branch="branch"></BranchPOSettlement>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import POSModal from "@/components/modals/POS/index";
import BranchPOSettlement from "@/components/modals/POS/BranchPOSettlement";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "Branch-POS-Transactions",
  components: {
    MasterLayout,
    TableLoader,
    POSModal,
    BranchPOSettlement,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      vendor: "selectVendor",
      vendors: [],

      branchBalance: 0,
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      totalCharges: 0,
      totalChargesCount: 0,
      branch: null,
      branchId: null,
      status: "selectAStatus",
      terminalId: "",
      totalTransactions: 0,
      totalTransactionsAmount: 0,
      totalSuccessfulTransactions: 0,
      totalSuccessfulTransactionsAmount: 0,
      totalFailedTransactions: 0,
      totalFailedTransactionsAmount: 0,
      modalData: null,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      showLoader: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },

      continuationToken: "",
      previousToken: "",
      pages: 1,

      actionTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<div class="btn-group btn-group-sm" role="group">' +
              '<button type="button" class="btn btn-outline-secondary" :title="det" @click="showDetails(data)" >' +
              `{{ det }}` +
              "</button>" +
              '<button type="button" class="btn btn-outline-success ml-2" :title="det" @click="downloadReceipt(data.id)" >' +
              `{{ dwn }}` +
              "</button>" +
              "</div>",
            data: function () {
              return {
                data: {},
                det: this.$t("text.clickButtons.details"),
                dwn: this.$t("text.clickButtons.download"),
              };
            },
            // data: function () {
            //   return {
            //     data: {},
            //     det: this.$("text.actionButtons.details"),
            //   };
            // },
            methods: {
              showDetails(data) {
                this.$eventHub.$emit("showDetails", data);
              },
              downloadReceipt(id) {
                // console.log("download receipt");
                this.$eventHub.$emit("downloadReceipt", id);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.dateRange.start = this.$moment(this.$route.query.startDate).format(
        "D-M-YYYY"
      );
      this.dateRange.end = this.$moment(this.$route.query.endDate).format(
        "D-M-YYYY"
      );
    } else {
      this.dateRange.start = this.pluginStartDate;
      this.dateRange.end = this.pluginEndDate;

      this.$router.replace({
        name: this.$route.name,
        query: {
          branchId: this.$route.query.branchId
            ? this.$route.query.branchId
            : this.branch.id,
          groupId: this.$route.query.groupId,
          regionId: this.$route.query.regionId,
          dealerId: this.$route.query.dealerId,
          companyId: this.$route.query.companyId,
          startDate: this.$moment(this.pluginStartDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
          endDate: this.$moment(this.pluginEndDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
        },
      });
    }

    // this.dateRange.start = this.pluginStartDate;
    // this.dateRange.end = this.pluginEndDate;

    document.title = "POS Transactions:: Epump Retail Outlet";

    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `POS Transactions:: ${branch.name} Retail Outlet`;
    });

    this.$eventHub.$on("showDetails", (data) => {
      this.modalData = data;
      this.$modal.show("POSModal");
    });

    this.$eventHub.$on("downloadReceipt", (id) => {
      // this.modalData = data;
      this.downloadReceipt(id);
    });

    this.$eventHub.$on("refreshTransaction", () => {
      this.getTransactions();
      this.getPOSSummary();
      // this.getBranchBalance();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("showDetails");
    this.$eventHub.$off("downloadReceipt");
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.$router.replace({
          name: this.$route.name,
          query: {
            branchId: this.$route.query.branchId
              ? this.$route.query.branchId
              : this.branch.id,
            groupId: this.$route.query.groupId,
            regionId: this.$route.query.regionId,
            dealerId: this.$route.query.dealerId,
            companyId: this.$route.query.companyId,
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });

        this.getTransactions();
        this.getPOSSummary();
      }
    },
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getTransactions();
          this.getPOSSummary();
          // this.getBranchBalance();
          this.getVendors();
        }
      }
    },
    status: function (newStatus, oldStatus) {
      if (newStatus !== null && newStatus !== "selectAStatus") {
        this.getTransactions();
      }
    },

    vendor: function (newVendor, oldVendor) {
      if (newVendor !== null && newVendor !== "selectVendor") {
        this.getTransactions();
      }
    },
  },
  methods: {
    //modal
    openSettlementModal() {
      this.$modal.show("BranchPOSettlement");
    },

    //utilities
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    rowDataBound: function (args) {
      if (args.data["statusCode"] === "00") {
        args.row.cells[7].style.color = "green";
      } else {
        args.row.cells[7].style.color = "red";
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "paymentDate") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },

    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    revertNumber(number) {
      return Number(number.replace(/[^0-9.]+/g, ""));
    },

    savePdfFile(blob, filename) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE browser
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    },

    //Requests
    downloadReceipt(id) {
      this.axios({
        url: `${configObject.apiBaseUrl}/Pos/TransactionReceipt/${id}`,
        method: "GET",
        headers: configObject.authConfig().headers,
        responseType: "blob",
      })
        .then((response) => {
          const blob = response.data;
          let disposition = response.headers["content-disposition"];
          let depositionArr = disposition.split(";")[1];
          const fname = depositionArr
            .split("=")[1]
            .split("_")
            .join("_")
            .replace(/["']/g, "");
          this.savePdfFile(blob, fname);

          this.$toast.open({
            message: this.$t("text.omit.successfullyDownloaded"),
            type: "success",
            duration: 3000,
          });

          // this.isButtonDisabled = false;
          // $(".loader").hide();
        })
        .catch((error) => {
          // this.isButtonDisabled = false;
          // $(".loader").hide();

          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },

    getVendors() {
      this.axios
        .get(
          `${configObject.posBaseUrl}/POS/GetVendors`,
          configObject.remisConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          this.vendors = response.data;
        })
        .catch((error) => {});
    },

    handleNextPage() {
      this.newToken = this.continuationToken;
      this.pages++;
      this.getTransactions();
    },
    handlePreviousPage() {
      // this.newToken = this.previousToken;
      this.newToken = "";
      // this.pages--;
      this.pages = 1;
      this.getTransactions();
    },

    getTransactions() {
      this.showLoader = true;
      const status = this.status == "selectAStatus" ? "" : this.status;
      const vendor = this.vendor === "selectVendor" ? " " : this.vendor;

      let url = `${configObject.apiBaseUrl}/v2/POS/Entity/Transactions/${this.branchId}/branch?startDate=${this.$route.query.startDate}&endDate=${this.$route.query.endDate}&continuationToken=${this.continuationToken}&status=${status}&vendor=${vendor}`;

      this.axios
        .get(url, configObject.remisConfig())
        .then((response) => {
          let index = 0;
          this.continuationToken = response.data.data.continuationToken;
          this.previousToken = response.data.data.prevContinuationToken;

          response.data.data.transactions.forEach((cur) => {
            cur.index = ++index;
          });

          this.showLoader = false;

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data.data.transactions,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    getPOSSummary() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/v2/POS/Entity/Summary/${this.branchId}/branch?startDate=${this.$route.query.startDate}&endDate=${this.$route.query.endDate}`,
          configObject.remisConfig()
        )
        .then((response) => {
          this.totalTransactionsAmount = response.data.data.allSales;
          this.totalSuccessfulTransactionsAmount =
            response.data.data.successfulSales;
          this.totalFailedTransactionsAmount = response.data.data.failedSales;
          this.totalTransactions = response.data.data.allCount;
          this.totalSuccessfulTransactions = response.data.data.successfulCount;
          this.totalFailedTransactions = response.data.data.failedCount;
        })
        .catch((error) => {});
    },

    getBranchBalance() {
      this.axios

        .get(
          `${configObject.apiBaseUrl}/Pos/BranchBalance/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.branchBalance = this.convertThousand(response.data.balance);
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.e-grid .e-row:hover .e-rowcell {
  cursor: pointer;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

@media screen and (max-width: 602px) {
  .POSModal .v--modal-box.v--modal {
    margin: 0 auto;
    top: 112px !important;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
    overflow: auto;
  }
  .POSModal .v--modal-box.v--modal {
    margin: 0 auto;
    /* top: 88px !important; */
    width: 90% !important;
    height: 379px !important;
    left: 0 !important;
    overflow: auto;
  }
  button.add_quick_fuel_btn {
    margin-bottom: 62px;
  }
}
</style>
